define('app/sds/service/usage/power/sds-service-usage-power',["moment", "$timeout"], function (moment, $timeout) {
	"use strict";
	return {
		controller: {
			prototype: {
				series: [{
					field: "peak",
					name: "Peak Usage"
				}, {
					field: "offpeak",
					name: "Off-Peak Usage"
				}],
				valueAxis: {
					labels: {
						format: "{0} kWh"
					}
				},
				makeUsage: function (count) {
					var usage = [],
						peak = 3.5,
						peakVariation = 0.5,
						offpeak = 1.5,
						offpeakVariation = 0.5;
					for (var i = 0; i < count; i++) {
						usage.push({
							peak: peak + Math.random() * peakVariation,
							offpeak: offpeak + Math.random() * offpeakVariation
						});
					}
					return usage;
				},
				makeExtend: function (usage) {
					var categories = [];
					var now = moment().add(1, "days").startOf("day");
					return {
						dataSource: angular.map(usage, function (usage, i) {
							var date = now.subtract(1, "days");
							categories.push(date.format("D/M"));
							return {
								peak: usage.peak,
								offpeak: usage.offpeak,
								date: date.toDate()
							};
						}),
						categoryAxis: {
							categories: categories
						}
					};
				},
				circles: [{
					complete: 0.7
				}],
				alerts: {
					peak: 100,
					offpeak: 50
				}
			},
			constructor: ["$self", "$watch", function (vm, $watch) {
				angular.extend(vm, vm.makeExtend(vm.usage = vm.makeUsage(21)));
				vm.total = vm.usage.reduce(function (curr, total) {
					return {
						peak: curr.peak + total.peak,
						offpeak: curr.offpeak + total.offpeak
					}
				}, {
					peak: 0,
					offpeak: 0
				});
				$timeout(function () {
					vm.drawTheStupidChart = true;
				});
			}]
		}
	};
});
